import { css, type Theme } from "@emotion/react";

import { SLIDE_SCRIM_COLOR, slideContentInset } from "../../SideCarouselPanel.styles";

import qualityProgramSlideBg from "./assets/qualityProgramSlideBg.webp";

export const slide = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${slideContentInset(theme)};
  background-image:
    linear-gradient(${SLIDE_SCRIM_COLOR}, ${SLIDE_SCRIM_COLOR}), url(${qualityProgramSlideBg});
  background-size: cover;
  background-position: center;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  max-width: 360px;
`;

export const heading = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.medium};
`;

export const titleEmphasis = css`
  display: block;
  font-style: italic;
`;

export const features = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.large};
  margin-top: ${theme.ds5.spacing.gap.large};
`;
